function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useRef } from 'react';
import { Box, Button, IconButton, TextField, Typography } from '@applyboard/ui-components';
import { PlusOutlineIcon, DeleteOutlineIcon, CloseOutlineIcon } from '@applyboard/ui-icons';
import { DropdownField } from "../DropdownField";

// TODO: change this to use ~/data/requirements

export function QuestionsField(props) {
  return /*#__PURE__*/React.createElement("div", null, props.value.map(function (question, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      mb: 1
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      fullWidth: true,
      value: question.question,
      label: "Question #".concat(idx + 1),
      onChange: function onChange(e) {
        var newQuestion = _objectSpread(_objectSpread({}, question), {}, {
          question: e.target.value
        });
        var newValue = [].concat(_toConsumableArray(props.value.slice(0, idx)), [newQuestion], _toConsumableArray(props.value.slice(idx + 1)));
        props.onChange(newValue);
      },
      mr: 0.5,
      required: true
    }), /*#__PURE__*/React.createElement(DropdownField, {
      label: "Format",
      value: question.questionFormat,
      disabled: !!(question !== null && question !== void 0 && question.id),
      options: [{
        value: 'checkboxes',
        label: 'Checkboxes'
      }, {
        value: 'dropdown',
        label: 'Dropdown'
      }, {
        value: 'short_answer',
        label: 'Short Answer'
      }, {
        value: 'long_answer',
        label: 'Long Answer'
      }, {
        label: 'Date',
        value: 'date'
      }, {
        label: 'URL',
        value: 'url'
      }, {
        label: 'Number',
        value: 'number'
      }],
      onChange: function onChange(questionFormat) {
        var newQuestion = _objectSpread(_objectSpread({}, question), {}, {
          questionFormat: questionFormat,
          options: checkQuestionFormatSupportsOptions(questionFormat) ? question.options || [] : undefined
        });
        var newValue = [].concat(_toConsumableArray(props.value.slice(0, idx)), [newQuestion], _toConsumableArray(props.value.slice(idx + 1)));
        props.onChange(newValue);
      },
      ml: 0.5,
      required: true
    }), /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Remove question #".concat(idx + 1),
      disableFocusRipple: false,
      disableRipple: false,
      style: {
        outline: 'none'
      },
      onClick: function onClick() {
        props.onChange([].concat(_toConsumableArray(props.value.slice(0, idx)), _toConsumableArray(props.value.slice(idx + 1))));
      }
    }, /*#__PURE__*/React.createElement(DeleteOutlineIcon, {
      color: "negative"
    }))), checkQuestionFormatSupportsOptions(question.questionFormat) && /*#__PURE__*/React.createElement(OptionsListField, {
      disallowAdd: !!(question !== null && question !== void 0 && question.id),
      disallowRemove: !!(question !== null && question !== void 0 && question.id),
      value: question.options,
      onChange: function onChange(options) {
        var newQuestion = _objectSpread(_objectSpread({}, question), {}, {
          options: options
        });
        props.onChange([].concat(_toConsumableArray(props.value.slice(0, idx)), [newQuestion], _toConsumableArray(props.value.slice(idx + 1))));
      }
    }));
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "text",
    startIcon: /*#__PURE__*/React.createElement(PlusOutlineIcon, null),
    onClick: function onClick() {
      props.onChange([].concat(_toConsumableArray(props.value), [{
        question: '',
        questionFormat: ''
      }]));
    },
    ml: -1.5,
    mr: 1
  }, "Add Question"), props.error && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    variant: "caption"
  }, props.helperText)));
}
function checkQuestionFormatSupportsOptions(questionFormat) {
  return ['checkboxes', 'dropdown'].includes(questionFormat);
}
function OptionsListField(props) {
  var value = props.value || [];
  var addOptionRef = useRef();
  var options = _toConsumableArray(value);
  if (!props.disallowAdd) {
    options.push(null);
  }
  return /*#__PURE__*/React.createElement(Box, {
    ml: 2,
    mb: 2,
    mt: 0.5
  }, options.map(function (option, optionIdx) {
    return option !== null ? /*#__PURE__*/React.createElement(Box, {
      key: optionIdx,
      mb: 1,
      display: "flex"
    }, /*#__PURE__*/React.createElement(TextField, {
      value: option,
      label: "Option #".concat(optionIdx + 1),
      onChange: function onChange(e) {
        props.onChange([].concat(_toConsumableArray(value.slice(0, optionIdx)), [e.target.value], _toConsumableArray(value.slice(optionIdx + 1))));
      },
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === 13) {
          var _addOptionRef$current;
          (_addOptionRef$current = addOptionRef.current) === null || _addOptionRef$current === void 0 ? void 0 : _addOptionRef$current.focus();
        }
      },
      variant: "outlined",
      fullWidth: true
    }), !props.disallowRemove && /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Remove option #".concat(optionIdx + 1),
      disableFocusRipple: false,
      disableRipple: false,
      style: {
        outline: 'none'
      },
      onClick: function onClick() {
        props.onChange([].concat(_toConsumableArray(value.slice(0, optionIdx)), _toConsumableArray(value.slice(optionIdx + 1))));
      }
    }, /*#__PURE__*/React.createElement(CloseOutlineIcon, {
      color: "negative"
    }))) : /*#__PURE__*/React.createElement(Box, {
      key: optionIdx,
      mb: 1,
      display: "flex",
      mr: props.disallowRemove ? 0 : 6
    }, /*#__PURE__*/React.createElement(TextField, {
      label: "Type to add option...",
      value: "",
      onChange: function onChange(e) {
        props.onChange([].concat(_toConsumableArray(value), [e.target.value]));
      },
      variant: "outlined",
      inputRef: addOptionRef,
      fullWidth: true
    }));
  }));
}
export var validateQuestions = function validateQuestions(value) {
  var isValid = value.every(function (v) {
    var optionsValid = !['checkboxes', 'dropdown'].includes(v.questionFormat) || v.options.length > 0 && v.options.every(Boolean);
    return v.question.length > 0 && v.questionFormat.length > 0 && optionsValid;
  });
  if (!isValid) {
    return 'Please ensure all questions are complete';
  }
  return true;
};